import { wrap, releaseProxy, proxy } from 'comlink';

/**
 * Edf handles initializing of an edf file, including parsing of the header, annotations, and data points.
 */
class Edf {
    constructor() {
        this.worker = new Worker(new URL('./worker/index', import.meta.url), {
            name: 'edf',
            type: 'module',
        });
        this.wrappedWorker = wrap(this.worker);
    }

    setFiles(edf, annotations) {
        this.edfFile = edf;
        this.annotationsFile = annotations;
    }

    async initialize() {
        await this.wrappedWorker.initialize(this.edfFile, this.annotationsFile);
        // TODO: To make EDF more generic, add a subscription mechanism
        //  instead of having a loader callback which is too UI specific.
    }

    cleanup() {
        if (this.wrappedWorker) {
            // https://blog.logrocket.com/integrating-web-workers-in-a-react-app-with-comlink/ TODO: READ
            this.wrappedWorker[releaseProxy]();
            this.worker.terminate();
        }
    }

    async getHeaders() {
        return this.wrappedWorker.getHeaders();
    }

    async getAnnotations() {
        return this.wrappedWorker.getAnnotations();
    }

    async aggregateChannel(channelId, validRegions) {
        return this.wrappedWorker.aggregateChannel(channelId, validRegions);
    }

    async getAllChannelData(start, end, options, callback) {
        let proxyCallback;

        if (callback) {
            proxyCallback = proxy(callback);
        }

        return this.wrappedWorker.getAllChannelData(start, end, options, proxyCallback);
    }
}

const edfInstance = new Edf();
const edfProxy = new Proxy(edfInstance, {
    get(target, prop, receiver) {
        if (!target.edfFile && prop !== 'setFiles') {
            throw new Error(
                'The Edf service needs to specify which files to work with, please call the method `setFiles` first.'
            );
        }

        const value = target[prop];

        return value instanceof Function ? value.bind(target) : value;
    },
});

export default edfProxy;
